import HomeSection from '../sections/HomeSection'

const HomePage = () => <HomeSection />

export default HomePage
